import { platformStats } from '@/mocks/home';

export default function StatsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-950">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {platformStats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="font-heading text-3xl md:text-5xl font-bold text-primary-400 mb-2">
                {stat.value}
              </div>
              <p className="text-background-50/50 text-sm">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}